export const PL_PLAYERS = {
  GK: [
    'david-raya-martin-2024-limited-426',
    'ederson-santana-de-moraes-2024-limited-450',
    'damian-emiliano-martinez-2024-limited-422',
    'nick-pope-2024-limited-431',
    'mark-flekken-2024-limited-445',
    'matz-sels-2024-limited-441',
    'bart-verbruggen-2024-limited-473',
    'jordan-pickford-2024-limited-448',
    'dean-henderson-2024-limited-454',
  ],
  DEF: [
    'cristian-gabriel-romero-2024-limited-409',
    'gabriel-dos-santos-magalhaes-2024-limited-423',
    'josko-gvardiol-2024-limited-402',
    'lewis-hall-2004-09-08-2024-limited-234',
    'neco-williams-2024-limited-488',
    'virgil-van-dijk-2024-limited-431',
    'ashley-young-2024-limited-435',
    'marc-guehi-2024-limited-257',
    'lisandro-martinez-2024-limited-21',
  ],
  MD: [
    'moises-isaac-caicedo-corozo-2024-limited-438',
    'philip-foden-2024-limited-455',
    'carlos-balepa-noom-quomah-2024-limited-346',
    'mikkel-damsgaard-2024-limited-356',
    'declan-rice-2024-limited-392',
    'bruno-guimaraes-rodriguez-moura-2024-limited-374',
    'emile-smith-rowe-2024-limited-407',
    'bruno-miguel-borges-fernandes-2024-limited-31',
    'mario-lemina-2024-limited-337',
  ],
  FW: [
    'luis-fernando-diaz-marulanda-2024-limited-389',
    'bryan-mbeumo-2024-limited-411',
    'chris-wood-2024-limited-425',
    'alexander-isak-2024-limited-418',
    'dominic-solanke-2024-limited-378',
    'erling-haland-2024-limited-435',
    'ollie-watkins-2024-limited-415',
    'jarrod-bowen-2024-limited-421',
    'joao-pedro-junqueira-de-jesus-2024-limited-15',
  ],
};

export const LALIGA_PLAYERS = {
  GK: [
    'sergio-herrera-piron-2024-limited-396',
    'rui-tiago-dantas-da-silva-2024-limited-384',
    'julen-agirrezabala-astulez-2024-limited-420',
    'thibaut-courtois-2024-limited-361',
    'ignacio-pena-sotorres-2024-limited-442',
    'jan-oblak-2024-limited-424',
    'alejandro-remiro-gargallo-2024-limited-414',
    'vicente-guaita-panadero-2024-limited-365',
    'karl-jakob-hein-2024-limited-244',
  ],
  DEF: [
    'inigo-martinez-berridi-2024-limited-389',
    'naif-aguerd-2024-limited-310',
    'diego-javier-llorente-rios-2024-limited-374',
    'alejandro-catena-marugan-2024-limited-441',
    'florian-lejeune-2024-limited-451',
    'antonio-rudiger-2024-limited-360',
    'jose-maria-gimenez-de-vargas-2024-limited-360',
    'loic-bade-2024-limited-301',
    'yarek-gasiorowski-hernandis-2024-limited-255',
  ],
  MD: [
    'giovani-lo-celso-2024-limited-321',
    'marc-casado-torras-2024-limited-19',
    'martin-zubimendi-ibanez-2024-limited-394',
    'joao-lucas-de-souza-cardoso-2024-limited-347',
    'daniel-parejo-munoz-2024-limited-302',
    'jude-bellingham-2024-limited-434',
    'rodrigo-javier-de-paul-2024-limited-324',
    'moriba-kourouma-kourouma-2024-limited-262',
    'oihan-sancet-tirapu-2024-limited-388',
  ],
  FW: [
    'raphael-dias-belloli-2024-limited-393',
    'vinicius-jose-paixao-de-oliveira-junior-2024-limited-430',
    'raul-moro-prescoli-2024-limited-417',
    'thierno-barry-2002-10-21-2024-limited-48',
    'takefusa-kubo-2024-limited-410',
    'nicholas-williams-arthuer-2024-limited-478',
    'antoine-griezmann-2024-limited-422',
    'iago-aspas-juncal-2024-limited-327',
    'lamine-yamal-nasraoui-ebana-2024-limited-464',
  ],
};

export const BUNDESLIGA_PLAYERS = {
  GK: [
    'kevin-trapp-2024-limited-395',
    'noah-atubolu-2024-limited-428',
    'moritz-nicolas-2024-limited-424',
    'manuel-neuer-2024-limited-375',
    'oliver-baumann-2024-limited-186',
    'alexander-nubel-2024-limited-291',
    'peter-gulacsi-2024-limited-449',
    'robin-zentner-2024-limited-402',
    'gregor-kobel-2024-limited-425',
  ],
  DEF: [
    'keven-schlotterbeck-2024-limited-327',
    'min-jae-kim-2024-limited-415',
    'nico-schlotterbeck-2024-limited-408',
    'maximilian-mittelstadt-2024-limited-93',
    'lucas-silva-melo-2024-limited-368',
    'willi-orban-2024-limited-323',
    'alejandro-grimaldo-garcia-2024-limited-389',
    'konstantinos-koulierakis-2024-limited-196',
    'anthony-caci-2024-limited-436',
  ],
  MD: [
    'rocco-reitz-2024-limited-339',
    'jamal-musiala-2024-limited-413',
    'tom-bischof-2024-limited-370',
    'florian-wirtz-2024-limited-447',
    'felix-kalu-nmecha-2024-limited-391',
    'enzo-millot-2024-limited-355',
    'amadou-haidara-2024-limited-294',
    'julian-weigl-2024-limited-21',
    'jae-sung-lee-2024-limited-526',
  ],
  FW: [
    'omar-marmoush-2024-limited-377',
    'serhou-guirassy-2024-limited-381',
    'alexis-claude-maurice-2024-limited-89',
    'alassane-plea-2024-limited-345',
    'donyell-malen-2024-limited-8',
    'hugo-ekitike-2024-limited-414',
    'benjamin-sesko-2024-limited-431',
    'mohamed-el-amine-amoura-2024-limited-286',
    'jonathan-burkardt-2024-limited-433',
  ],
};
